import { useState } from "react";
import { visionURL } from "../../config/environment";
import Jsona from "jsona";
import JsonApiService from "../../services/jsonapiService";

const dataFormatter = new Jsona();

const positionsApiService = async () =>
  new JsonApiService("positions", {
    baseUrl: `${visionURL}/api`,
    credentials: "include"
  });

export const usePositions = () => {
  const [isLoading, setIsLoading] = useState(false);
  return {
    getPositions: async ({
      page,
      sort,
      filters,
      include = [],
      fields = {}
    }) => {
      setIsLoading(true);
      const service = await positionsApiService();
      const response = await service
        .page(page)
        .sort(sort)
        .where(filters)
        .include(include)
        .fields(fields)
        .all()
        .then(response => response.json());
      setIsLoading(false);
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    },
    isLoading
  };
};
